import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import { IMaskInput } from "react-imask";
import {Card, Form, Button, Row, Col, Table, Dropdown, Spinner} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaEye, FaEraser, FaTimes, FaSortUp, FaSortDown, FaExclamationTriangle, FaCheckDouble, FaTrash, FaColumns, FaList } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { hasPerm, formataDataHoraExibicao, getCurrentUser, tiposAcesso, calcularTempoNaEtapa, formataDataExibicao } from '../../common/utils';
import moment from "moment-timezone";
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import ExportPDF from './ExportPDF';
import ExportCSVExcel from './ExportCSVExcel';
import KanbanAtendimentos from './Kanban/KanbanAtendimentos';
import LinhasDensasAtendimentos from './LinhasDensasAtendimentos';
import { usaLayoutNovoListas } from '../../common/config';

class Atendimentos extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaRegistro = this.buscaRegistro.bind(this);
        this.handleFiltroClick = this.handleFiltroClick.bind(this);
        this.limpaFiltro = this.limpaFiltro.bind(this);
        this.handleOrderChange = this.handleOrderChange.bind(this);
        this.handleLimiteChange = this.handleLimiteChange.bind(this);

        this.carregaProgramasDelay = this.delayCamposAsync(this.carregaProgramas, 3000);
        this.carregaDoencasDelay = this.delayCamposAsync(this.carregaDoencas, 3000);
        this.carregaEtapasDelay = this.delayCamposAsync(this.carregaEtapas, 3000);
        this.carregaStatusProgramaDelay = this.delayCamposAsync(this.carregaStatusPrograma, 3000);
        this.carregarMedicosDelay = this.delayCamposAsync(this.carregarMedicos, 3000);
        this.carregaCamposPersonalizadosDelay = this.delayCamposAsync(this.carregaCamposPersonalizados, 3000);

        this.state = {
            listRegistros: [],
            // visao kanban (somente leitura) alternativa a listagem
            visao_kanban: false,
            //so para o gate do layout anterior; sai quando a validacao terminar
            configProgramaAtual: null,
            //o painel de filtros fica aberto ate o usuario fechar, para filtrar e ver o
            //resultado abaixo sem reabrir a cada ajuste
            filtros_abertos: false,
            error: "",
            busca: "",
            laboratorio_id: "",
            laboratorio_nome: "",
            filtro_programa_id: '',
            filtro_programa_nome: '',
            atendimento_validado: '',
            cadastro_teste: '',
            ordem: '',
            ordem_direcao: '',
            limite: 20,
            atendente_id: "",
            beneficiario_id: "",
            opcao_mensageria_selecionada:[],
            atendimento_totais:[],
            cliente_id: "",
            etapa_id: "",
            etapa_nome: "",
            tempo_na_etapa: "",
            data_ultima_modificacao: "",
            filtro_status: "todos",
            programa_id: "",
            paciente_id: "",
            beneficiario_nome: "",
            beneficiario_cpf: "",
            page_numb: 1,
            etapa_select_key: 0,
            loading: true,
            loading_render: true,
            permite_editar: true,
            gestor_interno: false,
            temp_busca: "",
            temp_beneficiario_cpf: "",
            temp_laboratorio_nome: "",
            temp_filtro_programa_id: '',
            temp_filtro_programa_nome: '',
            temp_filtro_atendimento_validado: '',
            temp_cadastro_teste: '',
            temp_etapa_id: '',
            temp_etapa_nome: '',
            temp_status_id: '',
            temp_status_nome: '',
            status_id: "",
            status_nome: "",
            temp_telefone_celular: "",  
            temp_doenca_id: "", 
            temp_doenca_nome: "", 
            temp_atendimento_id: '',
            atendimento_id: '',
            temp_medico_id: '',
            temp_medico_nome: '',
            medico_id: '',
            medico_nome: '',
            filtros_atendimento_padrao: [
                {id: null, slug: "acoes_dia", nome: "Atividades do Dia",  ordem: 0, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, temp: ""},
                {id: null, slug: "acao_navegador", nome: "Ação Navegador",  ordem: 1, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, temp: ""},
                {id: null, slug: "andamento", nome: "Andamento", ordem: 2, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, temp: ""},
                {id: null, slug: "finalizados", nome: "Finalizados", ordem: 3, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, temp: ""},
                {id: null, slug: "cancelados", nome: "Cancelados", ordem: 4, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, temp: ""},
                {id: null, slug: "todos", nome: "Todos",  ordem: 5, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, temp: ""},
                {id: null, slug: "nome_paciente", nome: "Nome do Paciente", ordem: 0, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, temp: ""},
                {id: null, slug: "cpf_paciente", nome: "CPF do Paciente", ordem: 1, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, temp: ""},
                {id: null, slug: "patologia", nome: "Patologia", ordem: 2, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, temp: ""},
                {id: null, slug: "nome_laboratorio", nome: "Nome do Laboratório", ordem: 3, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, temp: ""},
                {id: null, slug: "programa", nome: "Programa", ordem: 4, padrao: false, tipo: 'filtro_avancado', exibir_filtro: false, temp: ""},
                {id: null, slug: "etapa", nome: "Etapa", ordem: 5, padrao: false, tipo: 'filtro_avancado', exibir_filtro: false, temp: ""},
                {id: null, slug: "status", nome: "Status", ordem: 6, padrao: false, tipo: 'filtro_avancado', exibir_filtro: false, temp: ""},
                {id: null, slug: "atendente", nome: "Atendente", ordem: 7, padrao: false, tipo: 'filtro_avancado', exibir_filtro: false, temp: ""}
            ],
            colunas_atendimento_padrao: [
                {id: null, slug: "paciente", nome: "Paciente", ordem: 0, show: false, exibir_campo: true},
                {id: null, slug: "laboratorio", nome: "Laboratório", ordem: 1, show: false, exibir_campo: true},
                {id: null, slug: "data_cadastro", nome: "Data Cadastro", ordem: 2, show: false, exibir_campo: true},
                {id: null, slug: "ultima_modificacao", nome: "Última Modificação", ordem: 3, show: false, exibir_campo: true},
                {id: null, slug: "programa", nome: "Programa", ordem: 4, show: false, exibir_campo: true},
                {id: null, slug: "status", nome: "Status", ordem: 5, show: false, exibir_campo: true},
                {id: null, slug: "etapa", nome: "Etapa", ordem: 6, show: false, exibir_campo: true},
                {id: null, slug: "tempo_etapa", nome: "Tempo na Etapa", ordem: 7, show: false, exibir_campo: true},
                {id: null, slug: "proxima_acao", nome: "Próxima Ação", ordem: 8, show: false, exibir_campo: true}
            ],
            programa_dados: {},
            programasOptions: [],
            loadingProgramas: false,
            doencasOptions: [],
            loadingDoencas: false,
            etapasOptions: [],
            loadingEtapas: false,
            medicosOptions: [],
            loadingMedicos: false,
            statusOptions: [],
            loadingStatus: false,
            camposPersonalizadosOptions: [],
            loadingCamposPersonalizados: false,
        };
    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        const searchParams = new URLSearchParams(this.props.router.location.search);
        const pacienteId = (searchParams.get('paciente')) ? searchParams.get('paciente') : '';
        const indicador = searchParams.get('indicador') || '';
        // Programa vindo do card da Home. Só vale para quem não tem programa fixo no
        // ambiente (admin), que de outra forma abriria a listagem sem filtro de programa.
        const programaIdUrl = (!dados_usuario['ambiente_programa_id'] && searchParams.get('programa_id')) || '';

        //Verifica se oculta o menu atendimentos
        if(dados_usuario['ambiente_programa_id']) {
            const programa_id = dados_usuario['ambiente_programa_id'];
            const cachedOcultarReceptivos = localStorage.getItem(`programa_ocultar_receptivos_${programa_id}`);
            const cachedOcultarAtendimentos = localStorage.getItem(`programa_ocultar_atendimentos_${programa_id}`);

            if(cachedOcultarAtendimentos === 'sim' && cachedOcultarReceptivos === 'nao') {
                window.location.href = '/atendimentos-receptivo';
                return;
            }

            this.carregaDadosPrograma(dados_usuario['ambiente_programa_id']);
            this.carregarFiltrosAtendimentoPrograma(dados_usuario['ambiente_programa_id']);
            this.carregarColunasAtendimentoPrograma(dados_usuario['ambiente_programa_id']);
        }

        if (pacienteId) {
            this.carregaBeneficiarioPorId(pacienteId);
        }

        this.setState({
            paciente_id: pacienteId,
            loading_render: false,
            filtro_status: indicador || "todos",
            ...(programaIdUrl ? { filtro_programa_id: programaIdUrl, temp_filtro_programa_id: programaIdUrl } : {}),
        }, () => {
            this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, pacienteId, this.state.page_numb, indicador)
            this.carregarConfigProgramaAtual();
        });
    }

    //o programa em contexto muda quando o admin filtra por programa; a config precisa
    //acompanhar. O próprio método ignora repetição do mesmo id. (temporário — ver o
    //bloco do layout anterior)
    componentDidUpdate(prevProps, prevState) {
        if (prevState.filtro_programa_id !== this.state.filtro_programa_id) {
            this.carregarConfigProgramaAtual();
        }
    }

    carregaDadosPrograma = (programa_id) => {
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    const dadosResponse = response.data;
                    this.setState({ programa_dados: dadosResponse });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                });
        }
    };

    carregarFiltrosAtendimentoPrograma = async (programa_id) => {
        if (programa_id) {
            await api.get(`/programas/filtros-atendimentos/?programa_id=${programa_id}`)
                .then(response => {
                    const filtrosAtendimento = response.data;
                    // Mapeia os filtros do padrão e atualiza os campos de acordo com o slug
                    const updatedFiltrosAtendimento = this.state.filtros_atendimento_padrao.map(filtroPadrao => {
                        // Encontra o filtro que tem o mesmo slug no retorno da API
                        const filtroApi = filtrosAtendimento.find(filtro => filtro.slug === filtroPadrao.slug);
                        
                        if (filtroApi) {
                            // Atualiza os campos com os dados da API
                            return {
                                ...filtroPadrao, // mantém as propriedades existentes
                                id: filtroApi.id,
                                nome: filtroApi.nome,
                                ordem: filtroApi.ordem,
                                padrao: filtroApi.padrao,
                                exibir_filtro: filtroApi.exibir_filtro
                            };
                        }
                        // Se não encontrar, retorna o filtro padrão sem alteração
                        return filtroPadrao;
                    });
                    //console.log(updatedColunasAtendimento);
                    // Atualiza o estado com as colunas modificadas
                    this.setState({ filtros_atendimento_padrao: updatedFiltrosAtendimento });
                })
                .catch(error => {
                    console.error('Erro ao carregar filtros de atendimento:', error);
                    
                    let erro_msg = 'Erro ao carregar filtros de atendimento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    alterarValidacaoAtendimento = (validacao, atendimento_id) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Alterar Validação?',
            html: `Deseja alterar a validação do atendimento?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, alterar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('atendimento_validado', !validacao);
                //envia para api
                api({
                    method: "put",
                    url: '/atendimentos/'+atendimento_id+'/',
                    data: formData,
                })
                .then(response => {
                    const MySwal = withReactContent(Swal)

                    MySwal.fire({
                        title: 'Validação alterada com sucesso!',
                        icon: 'success',
                        html: 'Validação alterada com sucesso',
                        showCloseButton: true,
                    }).then((result) => {
                        location.reload();
                    });

                    
                })
                .catch(error => {
                    let erro_msg = 'Erro ao alterar a validação do atendimento, verifique os campos e tente novamente';            

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    Sentry.captureException(erro_msg);

                    const MySwal = withReactContent(Swal)
                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    })    
                    
                    this.setState({
                        loading: false,
                    })
                });
            }
        });        
    };

    carregarColunasAtendimentoPrograma = async (programa_id) => {
        if (programa_id) {
            await api.get(`/programas/colunas-atendimentos/?programa_id=${programa_id}`)
                .then(response => {
                    const colunasAtendimento = response.data;
                    // Mapeia as colunas do padrão e atualiza os campos de acordo com o slug
                    const updatedColunasAtendimento = this.state.colunas_atendimento_padrao.map(colunaPadrao => {
                        // Encontra a coluna que tem o mesmo slug no retorno da API
                        const colunaApi = colunasAtendimento.find(coluna => coluna.slug === colunaPadrao.slug);
                        
                        if (colunaApi) {
                            // Atualiza os campos com os dados da API
                            return {
                                ...colunaPadrao, // mantém as propriedades existentes
                                id: colunaApi.id,
                                nome: colunaApi.nome,
                                ordem: colunaApi.ordem,
                                exibir_campo: colunaApi.exibir_campo
                            };
                        }
                        // Se não encontrar, retorna a coluna padrão sem alteração
                        return colunaPadrao;
                    });
                    //console.log(updatedColunasAtendimento);
                    // Atualiza o estado com as colunas modificadas
                    this.setState({ colunas_atendimento_padrao: updatedColunasAtendimento });
                })
                .catch(error => {
                    console.error('Erro ao carregar colunas atendimento:', error);
                    
                    let erro_msg = 'Erro ao carregar colunas de atendimento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregaBeneficiarioPorId = async (pacienteId) => {
        let dados_usuario = getCurrentUser();
        const cliente_id = (dados_usuario['ambiente_cliente_id']) ? dados_usuario['ambiente_cliente_id'] : '';
        if(cliente_id) {
            try {
                const response = await api.get(`/pessoas/beneficiarios/${pacienteId}/?cliente_id=${cliente_id}`);
                if (response.data) {
                    this.setState({
                        beneficiario_nome: response.data.nome
                    })
                }
            } catch (error) {
                console.error('Erro ao carregar beneficiário por ID:', error);
            }
        }
    };

    // Programa em que o kanban se baseia: o do ambiente ou o do filtro. Sem programa
    // não há colunas (as colunas são as etapas dele), então o alternador some.
    getProgramaIdKanban = () => {
        const dados_usuario = getCurrentUser();
        return dados_usuario['ambiente_programa_id'] || this.state.filtro_programa_id || null;
    };

    // Kanban é visão de acompanhamento da operação: navegadora, gestor interno e
    // superadmin. Prestador e paciente continuam só na listagem.
    podeVerKanban = () => {
        const dados_usuario = getCurrentUser();
        const tipo = dados_usuario['tipo_usuario'];

        return !!dados_usuario['is_superuser'] || this.state.gestor_interno || tipo === 'operador' || tipo === '';
    };

    // Os filtros do kanban são os MESMOS da listagem (abas do topo, busca, filtros
    // avançados) — só a etapa é retirada, porque no kanban ela é a coluna.
    getFiltrosKanban = () => {
        const { etapa_id, page, limit, ...filtros } = this.getFiltrosExport();
        return filtros;
    };

    // Monta os filtros ativos da listagem para a exportação CSV/Excel refletir
    // exatamente o que está sendo exibido na tela (mesma base do consultaRegistro).
    getFiltrosExport = () => {
        const dados_usuario = getCurrentUser();

        const filtros = {
            tipo_atendimento: 'programa',
            tipo_usuario: dados_usuario['tipo_usuario'],
        };

        if (this.state.paciente_id) {
            filtros.beneficiario_id = this.state.paciente_id;
        }

        if (dados_usuario['ambiente_cliente_id']) {
            filtros.cliente_id = dados_usuario['ambiente_cliente_id'];
            filtros.programa_id = dados_usuario['ambiente_programa_id'];
        }

        if (this.state.busca) {
            filtros.beneficiario_nome = this.state.busca;
        }

        if (this.state.beneficiario_cpf) {
            filtros.beneficiario_cpf = this.state.beneficiario_cpf;
        }

        if (this.state.filtro_status) {
            filtros.situacao_atendimento = this.state.filtro_status;
        }

        if (this.state.laboratorio_nome) {
            filtros.laboratorio_nome = this.state.laboratorio_nome;
        }

        if (this.state.filtro_programa_id) {
            filtros.programa_id = this.state.filtro_programa_id;
        }

        if (this.state.etapa_id) {
            filtros.etapa_id = this.state.etapa_id;
        }

        if (this.state.medico_id) {
            filtros.medico_id = this.state.medico_id;
        }

        if (this.state.status_id) {
            filtros.programa_status_id = this.state.status_id;
        }

        if (this.state.temp_telefone_celular) {
            filtros.telefone_celular = this.state.temp_telefone_celular;
        }

        if (this.state.doenca_id) {
            filtros.doenca_id = this.state.doenca_id;
        }

        if (this.state.atendimento_id) {
            filtros.atendimento_id = this.state.atendimento_id;
        }

        if (this.state.atendimento_validado) {
            filtros.atendimento_validado = this.state.atendimento_validado;
        }

        if (this.state.cadastro_teste) {
            filtros.cadastro_teste = this.state.cadastro_teste;
        }

        if (this.state.campo_personalizado_id && this.state.temp_campo_personalizado_valor) {
            filtros.campo_personalizado_id = this.state.campo_personalizado_id;
            filtros.campo_personalizado_valor = this.state.temp_campo_personalizado_valor;
        }

        return filtros;
    };

    async consultaRegistro(busca, beneficiario_cpf, paciente_id, page_numb=1, situacaoAtendimento=''){
        let dados_usuario = getCurrentUser();

        let url = `/atendimentos/?page=${page_numb}&tipo_atendimento=programa&beneficiario_id=${paciente_id}&tipo_usuario=${dados_usuario['tipo_usuario']}`;

        if(dados_usuario['ambiente_cliente_id']){
            url += `&cliente_id=${dados_usuario['ambiente_cliente_id']}&programa_id=${dados_usuario['ambiente_programa_id']}`;
        }

        //busca
        if(busca){
            url += `&beneficiario_nome=${busca}`;
        }

        if(beneficiario_cpf){
            url += `&beneficiario_cpf=${beneficiario_cpf}`;
        }

        if(situacaoAtendimento) {
            url += `&situacao_atendimento=${situacaoAtendimento}`;
        }

        if(this.state.laboratorio_nome){
            url += `&laboratorio_nome=${this.state.laboratorio_nome}`;
        }

        if(this.state.filtro_programa_id){
            url += `&programa_id=${this.state.filtro_programa_id}`;
        }

        if(this.state.etapa_id){
            url += `&etapa_id=${this.state.etapa_id}`;
        }

        if(this.state.medico_id){
            url += `&medico_id=${this.state.medico_id}`;
        }

        if(this.state.status_id){
            url += `&programa_status_id=${this.state.status_id}`;
        }

        if (this.state.temp_telefone_celular) {
            url += `&telefone_celular=${this.state.temp_telefone_celular}`;
        }

        if (this.state.doenca_id) {
            url += `&doenca_id=${this.state.doenca_id}`;
        }

        if(this.state.atendimento_id){
            url += `&atendimento_id=${this.state.atendimento_id}`;
        }

        if(this.state.ordem){
            url += `&order_by=${this.state.ordem}`;
        }

        if(this.state.ordem_direcao){
            url += `&order=${this.state.ordem_direcao}`;
        }

        if(this.state.atendimento_validado){
            url += `&atendimento_validado=${this.state.atendimento_validado}`;
        }

        if(this.state.cadastro_teste){
            url += `&cadastro_teste=${this.state.cadastro_teste}`;
        }
        
        if(this.state.campo_personalizado_id && this.state.temp_campo_personalizado_valor){
            url += `&campo_personalizado_id=${this.state.campo_personalizado_id}&campo_personalizado_valor=${this.state.temp_campo_personalizado_valor}`;
        }

        url += `&resumo_totais=1&limit=${this.state.limite}`;

        this.setState({
            loading: true
        });

        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data,
                atendimento_totais: response.data.totais,
            });
            this.verificaBloqueioEdicao();
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar atendimentos, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    // Alterar o número de registros por página
    handleLimiteChange(e) {
        const limite = e.target.value;
        this.setState({ limite, page_numb: 1 }, () => {
            this.consultaRegistro(this.state.busca, this.state.beneficiario_nome, this.state.paciente_id, 1);
        });
    }

    // Função para alterar a ordenação ao clicar nas setas
    handleOrderChange(campo) {
        const novaOrdem = campo;
        const novaOrdemDirecao = this.state.ordem === campo && this.state.ordem_direcao === 'asc' ? 'desc' : 'asc';

        this.setState({
            ordem: novaOrdem,
            ordem_direcao: novaOrdemDirecao,
        }, () => {
            this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, this.state.page_numb);
        });
    }

    excluirAtendimento = async (item) => {
        const MySwal = withReactContent(Swal);
        const atendimentoId = item.id;
        const pacienteNome = item?.dados_beneficiario?.nome || `ID ${item.beneficiario_id}`;

        const result = await MySwal.fire({
            title: 'Excluir atendimento?',
            html: `
                <div style="text-align: left;">
                    <p>Você está prestes a excluir o atendimento <strong>#${atendimentoId}</strong> do paciente <strong>${String(pacienteNome).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))}</strong>.</p>
                    <p class="text-danger"><strong>Atenção:</strong> Esta ação não pode ser revertida.</p>
                    <hr/>
                    <div class="mb-2">
                        <label for="swal-confirma-id" class="form-label">Para confirmar, digite o ID do atendimento (<strong>${atendimentoId}</strong>):</label>
                        <input id="swal-confirma-id" class="form-control" type="text" inputmode="numeric" autocomplete="off" placeholder="ID do atendimento" />
                    </div>
                </div>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar',
            focusConfirm: false,
            preConfirm: () => {
                const input = document.getElementById('swal-confirma-id');
                const valorDigitado = input ? input.value.trim() : '';
                if (valorDigitado !== String(atendimentoId)) {
                    Swal.showValidationMessage(`Digite o ID ${atendimentoId} para confirmar.`);
                    return false;
                }
                return true;
            }
        });

        if (!result.isConfirmed) return;

        Swal.fire({
            title: 'Excluindo atendimento...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            await api.delete(`/atendimentos/${atendimentoId}/`);
            MySwal.fire('Excluído!', 'O atendimento foi excluído com sucesso.', 'success');
            this.setState({ loading: true }, () => {
                this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, this.state.page_numb, this.state.filtro_status);
            });
        } catch (error) {
            console.error('Erro ao excluir atendimento', error);
            MySwal.fire('Erro!', 'Houve um erro ao tentar excluir o atendimento. Por favor, tente novamente.', 'error');
        }
    };


    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, num_page, this.state.filtro_status)
    };

    handleFiltroClick = (situacaoAtendimento) => {
        this.setState({
            filtro_status: situacaoAtendimento,
            page_numb: 1,
            loading: true,
        });
        this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, 1, situacaoAtendimento);
    };

    /*
    buscaRegistro(e) {
        e.preventDefault();

        // Atualizar os filtros efetivos com os valores temporários
        this.setState({
            busca: this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "nome_paciente").map(f => f.temp)[0],
            beneficiario_cpf: this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "cpf_paciente").map(f => f.temp)[0],
            laboratorio_nome: this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "nome_laboratorio").map(f => f.temp)[0],
            filtro_programa_id: this.state.temp_filtro_programa_id,
            filtro_programa_nome: this.state.temp_filtro_programa_nome,
            etapa_id: this.state.temp_etapa_id,
            etapa_nome: this.state.temp_etapa_nome,
            status_id: this.state.temp_status_id,
            status_nome: this.state.temp_status_nome,
            loading: true,
            page_numb: 1
        }, () => {
            //console.log(this.state.busca);
            this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, 1);
        });
    }
    */
    
    buscaRegistro(e) {
        e.preventDefault();
    
        // Atualizar os filtros efetivos com os valores temporários
        this.setState({
            busca: this.state.temp_busca,
            beneficiario_cpf: this.state.temp_beneficiario_cpf,
            laboratorio_nome: this.state.temp_laboratorio_nome,
            filtro_programa_id: this.state.temp_filtro_programa_id,
            filtro_programa_nome: this.state.temp_filtro_programa_nome,
            cadastro_teste: this.state.temp_cadastro_teste,
            atendimento_validado: this.state.temp_filtro_atendimento_validado,
            campo_personalizado_id: this.state.temp_campo_personalizado_id,
            campo_personalizado_nome: this.state.temp_campo_personalizado_nome,
            campo_personalizado_valor: this.state.temp_campo_personalizado_valor,
            campo_personalizado_tipo: this.state.temp_campo_personalizado_tipo,
            campo_personalizado_mascara: this.state.temp_campo_personalizado_mascara,
            campo_personalizado_slug: this.state.temp_campo_personalizado_slug,
            campo_personalizado_opcoes: this.state.temp_campo_personalizado_opcoes,
            etapa_id: this.state.temp_etapa_id,
            etapa_nome: this.state.temp_etapa_nome,
            status_id: this.state.temp_status_id,
            status_nome: this.state.temp_status_nome,
            temp_telefone_celular: this.state.temp_telefone_celular,  
            doenca_id: this.state.temp_doenca_id, 
            atendimento_id: this.state.temp_atendimento_id,
            medico_id: this.state.temp_medico_id,
            medico_nome: this.state.temp_medico_nome,
            loading: true,
            page_numb: 1
        }, () => {
            this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, 1);
        });
    }
    

    verificaBloqueioEdicao = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'industria') {
                this.setState({ permite_editar: false });
            }

            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'interno') {
                this.setState({ gestor_interno: true });
            }
        }
    }
    /*
    handleChangeFiltros = (event, fieldName) => {
        if (fieldName === 'programa_id') {
            this.setState({
                temp_filtro_programa_id: event.value,
                temp_filtro_programa_nome: event.label
            });
        } else if (fieldName === 'etapa_id') {
            this.setState({
                temp_etapa_id: event.value,
                temp_etapa_nome: event.label
            });
        } else if (fieldName === 'status_id') {
            this.setState({
                temp_status_id: event.value,
                temp_status_nome: event.label
            });
        } else {
            const { name, value } = event.target;
            const filtros_atendimento_padrao = [...this.state.filtros_atendimento_padrao];
            filtros_atendimento_padrao[fieldName] = { ...filtros_atendimento_padrao[fieldName], temp: value };    
            this.setState({ filtros_atendimento_padrao });        
        }
    };
    */
    handleChangeFiltros = (event, fieldName) => {
        if (fieldName === 'programa_id') {
            this.setState({
                temp_filtro_programa_id: event.value,
                temp_filtro_programa_nome: event.label,
                temp_campo_personalizado_nome: null,
                temp_campo_personalizado_valor: null,
                temp_campo_personalizado_tipo: null,
                temp_campo_personalizado_mascara: null,
                temp_campo_personalizado_slug: null,
                temp_campo_personalizado_opcoes: null,
                etapasOptions: [],
                loadingEtapas: false,
                medicosOptions: [],
                loadingMedicos: false,
                statusOptions: [],
                loadingStatus: false,
                camposPersonalizadosOptions: [],
                loadingCamposPersonalizados: false,
            });
        } else if (fieldName === 'etapa_id') {
            this.setState({
                temp_etapa_id: event.value,
                temp_etapa_nome: event.label
            });
        } else if (fieldName === 'medico_id') {
            this.setState({
                temp_medico_id: event.value,
                temp_medico_nome: event.label
            });
        } else if (fieldName === 'status_id') {
            this.setState({
                temp_status_id: event.value,
                temp_status_nome: event.label
            });
        } else if (fieldName === 'doenca_id') {
            this.setState({
                temp_doenca_id: event.value,
                temp_doenca_nome: event.label
            });
        } else if (fieldName === 'campo_personalizado_id') {
            this.setState({
                temp_campo_personalizado_id: event.value,
                temp_campo_personalizado_nome: event.label,
                temp_campo_personalizado_tipo: event.tipo,
                temp_campo_personalizado_mascara: event.mascara,
                temp_campo_personalizado_slug: event.slug,
                temp_campo_personalizado_opcoes: event.opcoes
            });
        } else {
            const { name, value } = event.target;
            this.setState({
                [name]: value
            });
        }
    };

    delayCamposAsync = (fn, delay = 3000) => {
        let timeout;

        return (...args) => {
            clearTimeout(timeout);

            return new Promise((resolve) => {
                timeout = setTimeout(async () => {
                    const result = await fn(...args);
                    resolve(result);
                }, delay);
            });
        };
    };
            
    carregaProgramas = async (inputValue = "") => {
        try {
            if (!inputValue) {this.setState({ loadingProgramas: true }); }

            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));

            if (!inputValue) {
                this.setState({
                    programasOptions: opcoes,
                    loadingProgramas: false
                });
            }
            return opcoes;
        } catch (error) {
            console.error("Erro ao carregar programas:", error);
            if (!inputValue) {this.setState({ loadingProgramas: false });}
            return [];
        }
    };

    carregaCamposPersonalizados = async (inputValue = "") => {
        const dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.temp_filtro_programa_id;

        if (!programa_id) {
            return [];
        }

        try {
            if (!inputValue) {this.setState({ loadingCamposPersonalizados: true });}

            const response = await api.get(`/atendimentos/campos/?programa_id=${programa_id}&nome=${inputValue}&filtrar_por_atendimento=1`);
            const opcoes = response.data.results
                // remove tudo cujo tipo seja 'checkbox' ou 'data'
                .filter(campo => campo.tipo !== "checkbox" && campo.tipo !== "data")
                .map(campo => ({
                    value: campo.id,
                    label: campo.nome,
                    tipo: campo.tipo,
                    mascara: campo.mascara,
                    slug: campo.slug,
                    opcoes: campo.opcoes,
                }));

            if (!inputValue) {
                this.setState({
                    camposPersonalizadosOptions: opcoes,
                    loadingCamposPersonalizados: false
                });
            }
            return opcoes;
        } catch (error) {
            console.error("Erro ao carregar campos personalizados:", error);
            if (!inputValue) {
                this.setState({ loadingCamposPersonalizados: false });
            }
            return [];
        }
    };


    carregaDoencas = async (inputValue = "") => {
        const dados_usuario = getCurrentUser();
        try {
            if (!inputValue) {this.setState({ loadingDoencas: true });}
            const programa_id = dados_usuario['ambiente_programa_id'];
            if (programa_id) {
                const response = await api.get(`/programas/doencas/?programa_id=${programa_id}&nome=${inputValue}`);
                const opcoes = response.data.results.map(doenca => ({
                    value: doenca.dados_doenca.id,
                    label: doenca.dados_doenca.nome
                }));

            if (!inputValue) {this.setState({
                    doencasOptions: opcoes,
                    loadingDoencas: false
                });}
                return opcoes;
            }
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));

            if (!inputValue) {this.setState({
                    doencasOptions: opcoes,
                    loadingDoencas: false
                });}
            return opcoes;
        } catch (error) {
            console.error("Erro ao carregar doenças:", error);
            if (!inputValue) {this.setState({ loadingDoencas: false });}
            return [];
        }
    };

    carregaEtapas = async (inputValue = "") => {
        const dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.temp_filtro_programa_id;

        if (!programa_id) {
            return [];
        }

        try {
            if (!inputValue) {this.setState({ loadingEtapas: true });}
            const response = await api.get(`/programas/etapas/?nome=${inputValue}&programa_id=${programa_id}&status=1`);
            const opcoes = response.data.results.map(etapa => ({
                value: etapa.id,
                label: etapa.nome
            }));

            if (!inputValue) {this.setState({
                    etapasOptions: opcoes,
                    loadingEtapas: false
                });
            }
            return opcoes;
        } catch (error) {
            console.error("Erro ao carregar etapas:", error);
            if (!inputValue) {
                this.setState({ loadingEtapas: false });
            }
            return [];
        }
    };

    carregaStatusPrograma = async (inputValue = "") => {
        const dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.temp_filtro_programa_id;

        if (!programa_id) {
            return [];
        }

        try {
            if (!inputValue) {this.setState({ loadingStatus: true });}
            const response = await api.get(`/programas/status/?nome=${inputValue}&programa_id=${programa_id}&status=1`);
            const opcoes = response.data.results.map(status => ({
                value: status.id,
                label: status.nome
            }));

            if (!inputValue) {
                this.setState({
                    statusOptions: opcoes,
                    loadingStatus: false
                });
            }
            return opcoes;
        } catch (error) {
            console.error("Erro ao carregar status do programa:", error);
            if (!inputValue) {
                this.setState({ loadingStatus: false });
            }
            return [];
        }
    };


    carregarMedicos = async (inputValue = "") => {
        const dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.temp_filtro_programa_id;

        if (!programa_id) {
            return [];
        }

        try {
            if (!inputValue) {this.setState({ loadingMedicos: true });}
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&programa_id=${programa_id}&status=1&is_active=1&categoria=medicos&tipo_usuario=${dados_usuario.tipo_usuario}`);
            const opcoes = response.data.results.map(medico => ({
                value: medico.id,
                label: `${medico.nome} (${medico.registro}/${medico.uf}) #${medico.id}`
            }));

            if (!inputValue) {
                this.setState({
                    medicosOptions: opcoes,
                    loadingMedicos: false
                });
            }
            return opcoes;
        } catch (error) {
            console.error("Erro ao carregar médicos:", error);
            if (!inputValue) {
                this.setState({ loadingMedicos: false });
            }
            return [];
        }
    };

    renderCampoPersonalizadoValor = (tipo) => {
        switch(tipo) {
            case 'texto':
            case 'area_texto':
            case 'data':
                return (
                    <Form.Control
                        type="text"
                        name="temp_campo_personalizado_valor"
                        value={this.state.temp_campo_personalizado_valor || ''}
                        onChange={(e) => this.setState({ temp_campo_personalizado_valor: e.target.value })}
                        placeholder="Digite o valor"
                        aria-label="Digite o valor"
                        aria-describedby="basic-addon2"
                    />
                );
            
            case 'selecao':
                return (
                    <Form.Control 
                        as="select"
                        value={this.state.temp_campo_personalizado_valor || ''}
                        onChange={(e) => this.setState({ temp_campo_personalizado_valor: e.target.value })}
                    >
                        <option value="">Selecione</option>
                        {this.state.temp_campo_personalizado_opcoes &&
                            this.state.temp_campo_personalizado_opcoes
                            .split('\n')
                            .map((opcao, index) => {
                                const [rawValue, rawLabel] = opcao.split(':');
                                const value   = rawValue.trim();
                                const label   = (rawLabel || rawValue).trim();
                                return (
                                <option key={index} value={value}>
                                    {label}
                                </option>
                                );
                            })}
                    </Form.Control>
                );
            
            case 'checkbox':
                return (
                    <>
                        {this.state.temp_campo_personalizado_opcoes && 
                            this.state.temp_campo_personalizado_opcoes.split('\n').map((opcao, index) => {
                                const [valor, label] = opcao.split(':');
                            return (
                                <Form.Check 
                                    key={index}
                                    type="checkbox"
                                    name="temp_campo_personalizado_valor"
                                    value={valor}
                                    checked={this.state.temp_campo_personalizado_valor && 
                                        this.state.temp_campo_personalizado_valor.split(',').includes(valor)}
                                    onChange={(e) => {
                                        const currentValues = this.state.temp_campo_personalizado_valor 
                                            ? this.state.temp_campo_personalizado_valor.split(',') 
                                            : [];
                                        
                                        const newValues = e.target.checked 
                                            ? [...currentValues, valor].filter(Boolean)
                                            : currentValues.filter(v => v !== valor);
                                        
                                        this.setState({ 
                                            temp_campo_personalizado_valor: newValues.join(',') 
                                        });
                                    }}
                                    label={label || valor}
                                />
                            );
                        })
                    }
                </>
                );
            
            case 'radio':
                return (
                    <>
                        {this.state.temp_campo_personalizado_opcoes && 
                            this.state.temp_campo_personalizado_opcoes.split('\n').map((opcao, index) => {
                                const [valor, label] = opcao.split(':');
                            return (
                                <Form.Check 
                                    key={index}
                                    type="radio"
                                    name="temp_campo_personalizado_valor"
                                    value={valor.trim()}
                                    checked={this.state.temp_campo_personalizado_valor === valor.trim()}
                                    onChange={(e) => {
                                        this.setState({ 
                                            temp_campo_personalizado_valor: valor.trim() 
                                        });
                                    }}
                                    label={label || valor}
                                />
                            );
                        })
                    }
                </>
                );
            
            /*case 'data':
                return (
                    <Form.Control
                        type="date"
                        mask="00/00/0000"
                        name="temp_campo_personalizado_valor"
                        value={this.state.temp_campo_personalizado_valor || ''}
                        onChange={(e) => this.setState({ temp_campo_personalizado_valor: e.target.value })}
                    />
                );*/
            
            default:
                return null;
        }
    }

    limpaFiltro() {
        // Limpar tanto os estados temporários quanto os efetivos
        this.setState({
            busca: '',
            beneficiario_cpf: '',
            laboratorio_nome: '',
            filtro_programa_id: null,
            etapa_id: null,
            medico_id: null,
            status_id: null,
            temp_busca: '',
            cadastro_teste: '',
            atendimento_validado: '',
            temp_beneficiario_cpf: '',
            temp_laboratorio_nome: '',
            temp_filtro_programa_id: null,
            temp_filtro_atendimento_validado: '',
            temp_cadastro_teste: '',
            atendimento_validado: '',
            temp_etapa_id: null,
            temp_medicoa_id: null,
            temp_status_id: null,
            temp_telefone_celular: '',
            temp_doenca_id: null,
            doenca_id: null,
            temp_atendimento_id: '',
            atendimento_id: '',
        }, () => {
            this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, 1);
        });
    }

    ExcluirFiltro = (filtro) => {
            if (filtro === 'programa_id') {
                this.setState({
                    filtro_programa_id: null,
                    filtro_programa_nome: '',
                    etapa_id: null,
                    etapa_nome: '',
                    medico_id: null,
                    medico_nome: '',
                    status_id: null,
                    status_nome: '',
                    temp_filtro_programa_id: null,
                    temp_filtro_programa_nome: '',
                    validacao_atendimento: '',
                    temp_etapa_id: null,
                    temp_etapa_nome: '',
                    temp_medico_id: null,
                    temp_medico_nome: '',
                    temp_status_id: null,
                    temp_status_nome: '',
                    page_numb: 1,
                }, () => {
                    this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, 1);
                });
            } else if (filtro === 'etapa_id') {
                this.setState({
                    etapa_id: null,
                    etapa_nome: '',
                    temp_etapa_id: null,
                    temp_etapa_nome: '',
                    page_numb: 1
                }, () => {
                    this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf,this.state.paciente_id, 1);
                });
            } else if (filtro === 'medico_id') {
                this.setState({
                    medico_id: null,
                    medico_nome: '',
                    temp_medico_id: null,
                    temp_medico_nome: '',
                    page_numb: 1
                }, () => {
                    this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf,this.state.paciente_id, 1);
                });
            } else if (filtro === 'status_id') {
                this.setState({
                    status_id: null,
                    status_nome: '',
                    temp_status_id: null,
                    temp_status_nome: '',
                    page_numb: 1
                }, () => {
                    this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, 1);
                });
            } else {
                this.setState({
                    [filtro]: '',
                    [`temp_${filtro}`]: '',
                    page_numb: 1
                }, () => {
                    this.consultaRegistro(this.state.busca, this.state.beneficiario_cpf, this.state.paciente_id, 1);
                });
            }
        }
    
    /* ------------------------------------------------------------------
     * LAYOUT ANTERIOR - e o padrao. O layout novo esta em validacao e so vale
     * para quem pedir.
     * O programa entra no layout novo gravando "agendamento": { "layout_listas": true }.
     * Para remover depois: apagar carregarConfigProgramaAtual, renderRows,
     * renderTabelaAnterior, o estado configProgramaAtual, o import de
     * usaLayoutNovoListas e o ramo do else no render.
     * ------------------------------------------------------------------ */
    carregarConfigProgramaAtual = async () => {
        const programaId = this.getProgramaIdKanban();
        if (!programaId) {
            if (this.state.configProgramaAtual !== null) this.setState({ configProgramaAtual: null });
            return;
        }
        if (this.programaConfigCarregado === programaId) return;
        this.programaConfigCarregado = programaId;

        let configuracoes = null;
        try {
            const cache = localStorage.getItem(`programa_configuracoes_${programaId}`);
            if (cache) configuracoes = JSON.parse(cache);
        } catch (e) {
            configuracoes = null;
        }
        if (configuracoes === null) {
            try {
                const resp = await api.get(`/programas/${programaId}/`);
                configuracoes = resp.data?.configuracoes || {};
            } catch (e) {
                return;
            }
        }
        this.setState({ configProgramaAtual: configuracoes });
    }
    renderRows = () => {

        const dados_usuario = getCurrentUser();
        const liberaColunas = (dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['tipo_usuario'] == '' || (dados_usuario['prestador_id'] > 0 && dados_usuario['prestador_categoria'] == "laboratorio_diagnostico")) ? true : false;

        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id} className="hover-row">
                <td data-label="ID" className="id-font">{item.id}</td>
                <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "paciente").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "paciente").map(c => c.nome)[0]}>
                    {(this.state.permite_editar) ? item.dados_beneficiario.nome : 'Id: '+item.beneficiario_id}
                </td>
                {dados_usuario['tipo_usuario'] !== 'prestador' && (

                <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "proxima_acao").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "proxima_acao").map(c => c.nome)[0]}>
                    {item.proxima_acao && item.proxima_acao.data_acao ? (
                        <>
                            {`${formataDataExibicao(item.proxima_acao.data_acao)} ${
                                (item.proxima_acao.hora_acao || '').split('.')[0].slice(0,5)
                            }`.trim()}
                            {(() => {
                                const currentDate = moment().tz("America/Sao_Paulo");
                                const actionDate = moment
                                    .tz(item.proxima_acao.data_acao, "America/Sao_Paulo")
                                    .startOf("day");
                                
                                if (actionDate.isSame(currentDate, "day")) {
                                    return <FaExclamationTriangle className="text-warning ms-1" />;
                                } else if (actionDate.isBefore(currentDate, "day")) {
                                    return <FaExclamationTriangle className="text-danger ms-1" />;
                                }
                                return null;
                            })()}
                        </>
                    ) : (
                        <>
                            -
                        </>
                    )}
                </td>
                )}
                {dados_usuario['tipo_usuario'] !== 'prestador' && (
                <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "laboratorio").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "laboratorio").map(c => c.nome)[0]}>
                    {(item.dados_laboratorio.nome) ? item.dados_laboratorio.nome : '--'}
                </td>
                )}
                <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "data_cadastro").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "data_cadastro").map(c => c.nome)[0]}>
                    {formataDataHoraExibicao(item.data)}
                </td>
                {liberaColunas && (
                    <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "ultima_modificacao").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "ultima_modificacao").map(c => c.nome)[0]}>
                        {formataDataHoraExibicao(item.data_atualizacao)}
                    </td>
                )}
                <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "programa").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "programa").map(c => c.nome)[0]}>
                    {item.dados_programa.nome}
                </td>
                <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "status").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "status").map(c => c.nome)[0]}>
                    {item.dados_programa_status.nome || '-'}
                </td>
                <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "etapa").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "etapa").map(c => c.nome)[0]}>
                    {item.cancelado ? 'Cancelado' : (item.finalizado ? 'Finalizado' : item.dados_etapa.nome)}
                </td>
                {liberaColunas &&(
                    <td style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "tempo_etapa").map(c => c.exibir_campo)[0] ? "" : "none"}} data-label={this.state.colunas_atendimento_padrao.filter(c => c.slug === "tempo_etapa").map(c => c.nome)[0]}>
                        {(!item.finalizado && !item.cancelado && item.dados_etapa_status && item.dados_etapa_status.data_cadastro) ? calcularTempoNaEtapa(item.dados_etapa_status.data_cadastro) : '-'}
                    </td>
                )}
                <td>
                    {this.state.permite_editar && (
                    <Button variant="light" href={"/atendimentos/edit/"+item.uuid} size="sm" className="custom-button border-white">
                        <FaEye /> Visualizar
                    </Button>
                    )}
                    {hasPerm('add_beneficiarios') && (
                        <Button variant="light" href={`/pacientes/edit/${item.beneficiario_id}/?cliente_id=${item.cliente_id}`} size="sm" className="custom-button border-white">
                            <FaRegEdit /> Paciente
                        </Button>
                    )}
                    {dados_usuario?.is_superuser && (
                        <Button
                            variant="link"
                            size="sm"
                            className="text-danger p-1"
                            title="Excluir atendimento"
                            aria-label="Excluir atendimento"
                            onClick={() => this.excluirAtendimento(item)}
                        >
                            <FaTrash />
                        </Button>
                    )}
                </td>
                {(dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['tipo_usuario'] == '') && (
                <td>
                    {(item.programa_id === 3 || item.programa_id === 2)  && (
                        <Button variant={item.atendimento_validado ? "success" : "danger"} className="text-center" size="sm" onClick={() => this.alterarValidacaoAtendimento(item.atendimento_validado, item.id)}>
                            <FaCheckDouble className="me-2" /> {item.atendimento_validado ? 'Validado' : 'Validar'}
                        </Button> 
                    )} 
                </td>
                )}
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={10}>Nenhum atendimento encontrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    renderTabelaAnterior = () => {
        //locais que viviam no render() da versao anterior e a tabela usa
        const dados_usuario = getCurrentUser();
        const liberaColunas = dados_usuario['operador_id'] > 0
            || dados_usuario['tipo_usuario'] === 'gestor'
            || dados_usuario['tipo_usuario'] === ''
            || (dados_usuario['prestador_id'] > 0 && dados_usuario['prestador_categoria'] === 'laboratorio_diagnostico');
        return (
            //a tabela vivia dentro do card na versao anterior; o layout novo fecha o card
            //antes da listagem, entao sem isto ela renderiza solta e vaza do container
            <Card className="cardDestaque">
                <Card.Body>
                    <div className="table-container">
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "paciente").map(c => c.exibir_campo)[0] ? "" : "none"}} onClick={() => this.handleOrderChange('beneficiario_nome')} className="cursor-pointer">
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "paciente").map(c => c.nome)[0]}
                                                <span className="sort-icons">
                                                    <FaSortUp className={`sort-up ${this.state.ordem === 'beneficiario_nome' && this.state.ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                    <FaSortDown className={`sort-down ${this.state.ordem === 'beneficiario_nome' && this.state.ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                </span>
                                            </th>
                                            {dados_usuario['tipo_usuario'] !== 'prestador' && (
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "proxima_acao").map(c => c.exibir_campo)[0] ? "" : "none"}} onClick={() => this.handleOrderChange('data')} className="cursor-pointer">
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "proxima_acao").map(c => c.nome)[0]}
                                                {/*<span className="sort-icons">
                                                    <FaSortUp className={`sort-up ${this.state.ordem === 'data' && this.state.ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                    <FaSortDown className={`sort-down ${this.state.ordem === 'data' && this.state.ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                </span>*/}
                                            </th>
                                            )}
                                            {dados_usuario['tipo_usuario'] !== 'prestador' && (
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "laboratorio").map(c => c.exibir_campo)[0] ? "" : "none"}}>
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "laboratorio").map(c => c.nome)[0]}
                                                {/*<span className="sort-icons">
                                                    <FaSortUp className={`sort-up ${this.state.ordem === 'laboratorio_nome' && this.state.ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                    <FaSortDown className={`sort-down ${this.state.ordem === 'laboratorio_nome' && this.state.ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                </span>*/}
                                            </th>
                                            )}
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "data_cadastro").map(c => c.exibir_campo)[0] ? "" : "none"}} onClick={() => this.handleOrderChange('data')} className="cursor-pointer">
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "data_cadastro").map(c => c.nome)[0]}
                                                <span className="sort-icons">
                                                    <FaSortUp className={`sort-up ${this.state.ordem === 'data' && this.state.ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                    <FaSortDown className={`sort-down ${this.state.ordem === 'data' && this.state.ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                </span>
                                            </th>
                                            {liberaColunas && (
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "ultima_modificacao").map(c => c.exibir_campo)[0] ? "" : "none"}} onClick={() => this.handleOrderChange('data_atualizacao')} className="cursor-pointer">
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "ultima_modificacao").map(c => c.nome)[0]}
                                                <span className="sort-icons">
                                                <FaSortUp className={`sort-up ${this.state.ordem === 'data_atualizacao' && this.state.ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                <FaSortDown className={`sort-down ${this.state.ordem === 'data_atualizacao' && this.state.ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                </span>
                                            </th>
                                            )}
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "programa").map(c => c.exibir_campo)[0] ? "" : "none"}}>
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "programa").map(c => c.nome)[0]}
                                            </th>
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "status").map(c => c.exibir_campo)[0] ? "" : "none"}}>
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "status").map(c => c.nome)[0]}
                                            </th>
                                            <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "etapa").map(c => c.exibir_campo)[0] ? "" : "none"}} onClick={() => this.handleOrderChange('etapa_id')} className="cursor-pointer">
                                                {this.state.colunas_atendimento_padrao.filter(c => c.slug === "etapa").map(c => c.nome)[0]}
                                                <span className="sort-icons">
                                                <FaSortUp className={`sort-up ${this.state.ordem === 'etapa_id' && this.state.ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                <FaSortDown className={`sort-down ${this.state.ordem === 'etapa_id' && this.state.ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                </span>
                                            </th>
                                            {liberaColunas && 
                                                <th style={{display: this.state.colunas_atendimento_padrao.filter(c => c.slug === "tempo_etapa").map(c => c.exibir_campo)[0] ? "" : "none"}} onClick={() => this.handleOrderChange('etapa_data_criacao')} className="cursor-pointer">
                                                    {this.state.colunas_atendimento_padrao.filter(c => c.slug === "tempo_etapa").map(c => c.nome)[0]}
                                                    <span className="sort-icons">
                                                    <FaSortUp className={`sort-up ${this.state.ordem === 'etapa_data_criacao' && this.state.ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                    <FaSortDown className={`sort-down ${this.state.ordem === 'etapa_data_criacao' && this.state.ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                    </span>
                                                </th>
                                            }
                                            <th></th>
                                            {(dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] === 'gestor') && (
                                            <th></th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderRows()}                                                   
                                    </tbody>
                                </Table>
                    </div>
                </Card.Body>
            </Card>
        );
    };

    render() {
        if (!hasPerm('view_atendimentos')) {
            return <Navigate to='/sem-permissao' />
        }

        if (this.state.loading_render) {
            return (
                <div className="text-center mt-5">
                    <Spinner animation="border" style={{ color: '#fff' }} />
                </div>
            );
        }

        let dados_usuario = getCurrentUser();

        const liberaColunas = (dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['tipo_usuario'] == '' || (dados_usuario['prestador_id'] > 0 && dados_usuario['prestador_categoria'] == "laboratorio_diagnostico")) ? true : false;
        const colspanSize = liberaColunas ? 10 : 8;

        // assessor técnico só filtra por Nome, CPF e Telefone
        const isAssessorTecnico = dados_usuario['tipo_usuario'] === 'prestador' && dados_usuario['prestador_categoria'] === 'assessor_tecnico';

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        {this.state.beneficiario_nome ? (
                            <h4 className="page-title">Atendimentos de {this.state.beneficiario_nome}</h4>
                        ) : (
                            <h4 className="page-title">{(dados_usuario['prestador_categoria'] === 'medicos') ? 'Cadastros' : 'Atendimentos'}</h4>
                        )}
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        {hasPerm('add_atendimentos') && !this.state.programa_dados.bloquear_inclusao_atendimento && (
                            <>
                                {dados_usuario?.prestador_categoria === 'medicos' ? (
                                    <Button variant="secondary" href="/atendimentos/add" className="mb-3" size="sm">
                                        <FaPlus /> Novo Cadastro
                                    </Button>
                                ) : (
                                    <>
                                        {this.state.paciente_id ? (
                                            <Button variant="secondary" href={`/atendimentos/add/?paciente=${this.state.paciente_id}`} className="mb-3" size="sm">
                                                <FaPlus /> Adicionar Atendimento
                                            </Button>
                                        ) : (
                                            <Button variant="secondary" href="/atendimentos/add" className="mb-3" size="sm">
                                                <FaPlus /> Adicionar Atendimento
                                            </Button>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={10}>
                                {(dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['tipo_usuario'] == '') && (
                                    <>
                                        {this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_rapido' && f.exibir_filtro === true).map((filtro, index) => {
                                            let total = 0;
                                            let filtro_slug = filtro.slug;
                                            if(filtro.slug == "todos"){
                                                total = this.state.atendimento_totais.atendimentos;
                                            }else if(filtro.slug == "andamento"){
                                                total = this.state.atendimento_totais["em_andamento"];
                                                filtro_slug = 'em_andamento';
                                            } else if(filtro.slug == "acoes_dia"){
                                                total = this.state.atendimento_totais["acao_dia"];
                                            } else {
                                                total = this.state.atendimento_totais[filtro.slug];
                                            }
                                            return  (
                                                <Button type="button" variant={(this.state.filtro_status == `${filtro.slug}`) ? "primary" : "outline-primary"} size="sm" onClick={() => this.handleFiltroClick(`${filtro_slug}`)} key={index}>
                                                    {filtro.nome} ({total})
                                                </Button>
                                            )
                                        })}
                                        {/*}
                                            <Button type="button" variant={(this.state.filtro_status == 'todos') ? "primary" : "outline-primary"} size="sm" onClick={() => this.handleFiltroClick('todos')}>
                                                Todos ({this.state.atendimento_totais.atendimentos})
                                            </Button>
                                            
                                            <Button type="button" variant={(this.state.filtro_status == 'acao_navegador') ? "primary" : "outline-primary"} size="sm"  onClick={() => this.handleFiltroClick('acao_navegador')}>
                                                Ação Navegador ({this.state.atendimento_totais.acao_navegador})
                                            </Button>

                                            <Button type="button" variant={(this.state.filtro_status == 'em_andamento') ? "primary" : "outline-primary"} size="sm"  onClick={() => this.handleFiltroClick('em_andamento')}>
                                                Andamento ({this.state.atendimento_totais.em_andamento})
                                            </Button>
                                            
                                            <Button type="button" variant={(this.state.filtro_status == 'finalizados') ? "primary" : "outline-primary"} size="sm"  onClick={() => this.handleFiltroClick('finalizados')}>
                                                Finalizados ({this.state.atendimento_totais.finalizados})
                                            </Button>
                                            
                                            <Button type="button" variant={(this.state.filtro_status == 'cancelados') ? "primary" : "outline-primary"} size="sm"  onClick={() => this.handleFiltroClick('cancelados')}>
                                                Cancelados ({this.state.atendimento_totais.cancelados})
                                            </Button>
                                            {*/}
                                        
                                    </>
                                )}
                            </Col>
                        </Row>
                        <Row className="align-items-center mt-3 mb-3">
                            <Col sm={6} lg={5}>
                                <div className="d-flex align-items-center">
                                    <Form.Select size="sm" value={this.state.limite} onChange={this.handleLimiteChange} style={{ width: 'auto' }}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </Form.Select>
                                    <span className="ms-2">registros por página</span>
                                </div>
                            </Col>
                            {/* coluna larga o bastante para os tres botoes ficarem lado a lado:
                                estreita, o texto quebrava em duas linhas e eles ficavam altos */}
                            <Col sm={6} lg={7} className="d-flex justify-content-end align-items-center gap-2">

                                {this.state.permite_editar && (dados_usuario.tipo_usuario === '' || dados_usuario.tipo_usuario === 'operador' || this.state.gestor_interno) && (
                                    <ExportCSVExcel getFiltros={this.getFiltrosExport} />
                                )}

                                {this.state.permite_editar && (dados_usuario.tipo_usuario === '' || dados_usuario.tipo_usuario === 'operador' || this.state.gestor_interno) && (
                                    <ExportPDF />
                                )}


                                {!this.state.paciente_id && this.state.permite_editar && (
                                    <Button
                                        variant={this.state.filtros_abertos ? "secondary" : "light"}
                                        size="sm"
                                        className="text-nowrap"
                                        onClick={() => this.setState({ filtros_abertos: !this.state.filtros_abertos })}
                                        aria-expanded={this.state.filtros_abertos}
                                    >
                                        <FaFilter /> Filtrar
                                    </Button>
                                )}
                                {/*<Button variant="light" className="ms-2" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>*/}
                            </Col>
                        </Row>   

                        {/* Painel de filtros dentro do card: abre e FICA aberto ate clicar de
                            novo no botao. Antes era um Dropdown, que fechava ao clicar fora e
                            obrigava a reabrir a cada ajuste de filtro. */}
                        {!this.state.paciente_id && this.state.permite_editar && this.state.filtros_abertos && (
                        <Row className="mb-3">
                            <Col sm={12}>
                                <div className="painel-filtros">
                                                <Form method="get" onSubmit={this.buscaRegistro}>
                                                    <Row>
                                                        <Col sm={12} xs={12} style={{display: this.state.filtros_atendimento_padrao.filter(f => (f.tipo === 'filtro_avancado' && f.slug === "nome_paciente") || dados_usuario['is_superuser']).map(f => f.exibir_filtro)[0] ? "block" : "none"}}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>{this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "nome_paciente").map(f => f.nome)[0]}</Form.Label>                                  
                                                                <Form.Control
                                                                    type="text"
                                                                    name="temp_busca"
                                                                    value={this.state.temp_busca}
                                                                    onChange={this.handleChangeFiltros}
                                                                    placeholder="Nome do paciente"
                                                                    aria-label="Nome do paciente"
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={12} xs={12} style={{display: this.state.filtros_atendimento_padrao.filter(f => (f.tipo === 'filtro_avancado' && f.slug === "cpf_paciente") || dados_usuario['is_superuser']).map(f => f.exibir_filtro)[0] ? "block" : "none"}}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>{this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "cpf_paciente").map(f => f.nome)[0]}</Form.Label>                                  
                                                                <Form.Control
                                                                    as={IMaskInput} 
                                                                    mask="000.000.000-00"
                                                                    name="temp_beneficiario_cpf"
                                                                    value={this.state.temp_beneficiario_cpf}
                                                                    onChange={this.handleChangeFiltros}
                                                                    placeholder="CPF do paciente"
                                                                    aria-label="CPF do paciente"
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {/* Telefone/Celular */}
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Telefone/Celular</Form.Label>                                  
                                                                <Form.Control
                                                                    as={IMaskInput} 
                                                                    mask="(00) 00000-0000"
                                                                    name="temp_telefone_celular"
                                                                    value={this.state.temp_telefone_celular}
                                                                    onChange={this.handleChangeFiltros}
                                                                    placeholder="Telefone ou Celular"
                                                                    aria-label="Telefone ou Celular"
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {/* Nome de Patologia */}
                                                        <Col sm={12} xs={12} style={{display: !isAssessorTecnico && this.state.filtros_atendimento_padrao.filter(f => (f.tipo === 'filtro_avancado' && f.slug === "patologia") || dados_usuario['is_superuser']).map(f => f.exibir_filtro)[0] ? "block" : "none"}}>
                                                            <Form.Group className="mb-3" size="sm">
                                                                <Form.Label>{this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "patologia").map(f => f.nome)[0]}</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregaDoencasDelay}
                                                                    defaultOptions={this.state.doencasOptions}
                                                                    onMenuOpen={() => this.carregaDoencas("")}
                                                                    isLoading={this.state.loadingDoencas}
                                                                    name="temp_doenca_id"
                                                                    placeholder={this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "patologia").map(f => f.nome)[0]}
                                                                    noOptionsMessage={() => "Nenhuma Patologia encontrada"}
                                                                    onChange={e => this.handleChangeFiltros(e, 'doenca_id')}
                                                                    value={this.state.temp_doenca_id ? { value: this.state.temp_doenca_id, label: this.state.temp_doenca_nome } : null}
                                                                    styles={{
                                                                        option: (provided) => ({
                                                                            ...provided,
                                                                            fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                        }),
                                                                    }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={12} xs={12} style={{display: !isAssessorTecnico && this.state.filtros_atendimento_padrao.filter(f => (f.tipo === 'filtro_avancado' && f.slug === "nome_laboratorio") || dados_usuario['is_superuser']).map(f => f.exibir_filtro)[0] ? "block" : "none"}}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>{this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "nome_laboratorio").map(f => f.nome)[0]}</Form.Label>                                  
                                                                <Form.Control
                                                                    type="text"
                                                                    name="temp_laboratorio_nome"
                                                                    value={this.state.temp_laboratorio_nome}
                                                                    onChange={this.handleChangeFiltros}
                                                                    placeholder="Nome do Laboratório"
                                                                    aria-label="Nome do Laboratório"
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {(dados_usuario['tipo_usuario'] == '' && !dados_usuario['ambiente_programa_id']) && (
                                                            <>
                                                                <Col sm={12} xs={12} style={{display: this.state.filtros_atendimento_padrao.filter(f => (f.tipo === 'filtro_avancado' && f.slug === "programa") || dados_usuario['is_superuser']).map(f => f.exibir_filtro)[0] ? "block" : "none"}}> 
                                                                    <Form.Group className="mb-3" size="sm">
                                                                        <Form.Label>{this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "programa").map(f => f.nome)[0]}</Form.Label>
                                                                        <AsyncSelect
                                                                            key={this.state.temp_filtro_programa_id}
                                                                            cacheOptions
                                                                            loadOptions={this.carregaProgramasDelay}
                                                                            defaultOptions={this.state.programasOptions}  
                                                                            onMenuOpen={() => this.carregaProgramas("")}  
                                                                            isLoading={this.state.loadingProgramas}
                                                                            name="temp_programa_id"
                                                                            placeholder="Nome do Programa"
                                                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                                            value={this.state.temp_filtro_programa_id ? { value: this.state.temp_filtro_programa_id, label: this.state.temp_filtro_programa_nome } : null}
                                                                            styles={{
                                                                                option: (provided) => ({
                                                                                ...provided,
                                                                                fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                                }),
                                                                            }}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                        )}
                                                        {(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['is_superuser'] || dados_usuario['operador_id'] > 0) && (dados_usuario['ambiente_programa_id'] || this.state.temp_filtro_programa_id) && (
                                                            <>
                                                                <Col sm={12} xs={12}> 
                                                                    <Form.Group className="mb-3" size="sm">
                                                                        <Form.Label>Campo Personalizado</Form.Label>
                                                                        <AsyncSelect
                                                                            key={this.state.temp_filtro_programa_id}
                                                                            cacheOptions
                                                                            loadOptions={this.carregaCamposPersonalizadosDelay}
                                                                            defaultOptions={this.state.camposPersonalizadosOptions} 
                                                                            onMenuOpen={() => this.carregaCamposPersonalizados("")} 
                                                                            isLoading={this.state.loadingCamposPersonalizados}
                                                                            name="temp_campo_personalizado_id"
                                                                            placeholder="Nome do Campo Personalizado"
                                                                            noOptionsMessage={() => "Nenhum campo personalizado encontrado"}
                                                                            onChange={e => this.handleChangeFiltros(e, 'campo_personalizado_id')}
                                                                            value={this.state.temp_campo_personalizado_id ? { value: this.state.temp_campo_personalizado_id, label: this.state.temp_campo_personalizado_nome } : null}
                                                                            styles={{
                                                                                option: (provided) => ({
                                                                                ...provided,
                                                                                fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                                }),
                                                                            }}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                {this.state.temp_campo_personalizado_id && (
                                                                <Col sm={12} xs={12} style={{display: this.state.temp_campo_personalizado_id ? "block" : "none"}}> 
                                                                    <Form.Group className="mb-3" size="sm">
                                                                        <Form.Label>Campo Personalizado Valor</Form.Label>
                                                                        {this.renderCampoPersonalizadoValor(this.state.temp_campo_personalizado_tipo)}
                                                                    </Form.Group>
                                                                </Col>
                                                                )}
                                                            </>
                                                        )}
                                                        {((dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['is_superuser']) || (dados_usuario['operador_id'] > 0 && dados_usuario['ambiente_programa_id'] && this.state.programa_dados.habilitar_validacao_atendimento)) && (
                                                        <Col sm={12} xs={12} > 
                                                            <Form.Group className="mb-3" size="sm">
                                                                <Form.Label>Validação do Atendimento</Form.Label>
                                                                    <Form.Control as="select" 
                                                                        name="temp_filtro_atendimento_validado"
                                                                        value={this.state.temp_filtro_atendimento_validado || ''}
                                                                        onChange={e => this.handleChangeFiltros(e, 'temp_filtro_atendimento_validado')}
                                                                    >
                                                                        <option value="">Selecione...</option>
                                                                        <option value="True">Validado</option>
                                                                        <option value="False">Não Validado</option>
                                                                    </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        )}
                                                        {!isAssessorTecnico && (this.state.temp_filtro_programa_id || dados_usuario['ambiente_programa_id']) && (
                                                        <Col sm={12} xs={12} style={{display: this.state.filtros_atendimento_padrao.filter(f => (f.tipo === 'filtro_avancado' && f.slug === "etapa") || dados_usuario['is_superuser']).map(f => f.exibir_filtro)[0] ? "block" : "none"}}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>{this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "etapa").map(f => f.nome)[0]}</Form.Label>
                                                                <AsyncSelect
                                                                    key={this.state.etapa_select_key}                                  
                                                                    cacheOptions
                                                                    loadOptions={this.carregaEtapasDelay}
                                                                    defaultOptions={this.state.etapasOptions}  
                                                                    onMenuOpen={() => this.carregaEtapas("")}  
                                                                    isLoading={this.state.loadingEtapas}
                                                                    name="temp_etapa_id"
                                                                    placeholder="Nome da Etapa"
                                                                    noOptionsMessage={() => "Nenhuma etapa encontrada"}
                                                                    onChange={e => this.handleChangeFiltros(e, 'etapa_id')}
                                                                    value={this.state.temp_etapa_id ? { value: this.state.temp_etapa_id, label: this.state.temp_etapa_nome } : null}
                                                                    styles={{
                                                                        option: (provided) => ({
                                                                          ...provided,
                                                                          fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                        }),
                                                                    }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        )}
                                                        {!isAssessorTecnico && ((this.state.temp_filtro_programa_id || dados_usuario['ambiente_programa_id']) || dados_usuario['is_superuser']) && (
                                                        <Col sm={12} xs={12} style={{display: this.state.filtros_atendimento_padrao.filter(f => (f.tipo === 'filtro_avancado' && f.slug === "status") || dados_usuario['is_superuser']).map(f => f.exibir_filtro)[0] ? "block" : "none"}}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>{this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado' && f.slug === "status").map(f => f.nome)[0]}</Form.Label>
                                                                <AsyncSelect
                                                                    key={this.state.status_select_key}                                  
                                                                    cacheOptions
                                                                    loadOptions={this.carregaStatusProgramaDelay}
                                                                    defaultOptions={this.state.statusOptions}          
                                                                    onMenuOpen={() => this.carregaStatusPrograma("")}  
                                                                    isLoading={this.state.loadingStatus}
                                                                    name="temp_status_id"
                                                                    placeholder="Status do Programa"
                                                                    noOptionsMessage={() => "Nenhum status encontrado"}
                                                                    onChange={e => this.handleChangeFiltros(e, 'status_id')}
                                                                    value={this.state.temp_status_id ? { value: this.state.temp_status_id, label: this.state.temp_status_nome } : null}
                                                                    styles={{
                                                                        option: (provided) => ({
                                                                          ...provided,
                                                                          fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                        }),
                                                                    }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        )}
                                                        {(this.state.temp_filtro_programa_id || dados_usuario['ambiente_programa_id']) && (dados_usuario['is_superuser'] || dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['tipo_usuario'] === 'gestor') && (
                                                        <Col sm={12} xs={12}> 
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Médico</Form.Label>
                                                                <AsyncSelect
                                                                    key={this.state.etapa_select_key}                                  
                                                                    cacheOptions
                                                                    loadOptions={this.carregarMedicosDelay}
                                                                    defaultOptions={this.state.medicosOptions}  
                                                                    onMenuOpen={() => this.carregarMedicos("")}    
                                                                    isLoading={this.state.loadingMedicos}
                                                                    name="temp_medico_id"
                                                                    placeholder="Médico"
                                                                    noOptionsMessage={() => "Nenhum médico encontrado"}
                                                                    onChange={e => this.handleChangeFiltros(e, 'medico_id')}
                                                                    value={this.state.temp_medico_id ? { value: this.state.temp_medico_id, label: this.state.temp_medico_nome } : null}
                                                                    styles={{
                                                                        option: (provided) => ({
                                                                          ...provided,
                                                                          fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                        }),
                                                                    }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        )}
                                                        {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['is_superuser']) && (
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Atendimento Teste?</Form.Label>
                                                                <Form.Control as="select" 
                                                                    name="temp_cadastro_teste"
                                                                    value={this.state.temp_cadastro_teste || ''}
                                                                    onChange={e => this.handleChangeFiltros(e, 'temp_cadastro_teste')}
                                                                >
                                                                    <option value="">Selecione...</option>
                                                                    <option value="True">Sim</option>
                                                                    <option value="False">Não</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        )}
                                                        <Col sm={12} xs={12} style={{display: isAssessorTecnico ? "none" : "block"}}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>ID Atendimento</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="temp_atendimento_id"
                                                                    value={this.state.temp_atendimento_id}
                                                                    onChange={this.handleChangeFiltros}
                                                                    placeholder="ID do Atendimento"
                                                                    aria-label="ID do Atendimento"
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    <Button type="submit" variant="primary" size="sm" className="me-2">
                                                        <FaSearch /> Filtrar
                                                    </Button>

                                                    <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                        <FaEraser /> Limpar Filtro
                                                    </Button>
                                                </Form>
                                </div>
                            </Col>
                        </Row>
                        )}

                        
                        {(() => {
                            const temFiltros = !!(this.state.busca || this.state.beneficiario_cpf || this.state.laboratorio_nome || this.state.filtro_programa_id || this.state.etapa_id || this.state.status_id || this.state.cadastro_teste || this.state.medico_id);
                            if (!temFiltros) return null;

                            return (
                            <Row className="align-items-center mt-3 mb-3">
                                <Col sm={12}>
                                    <p className="mb-0">Filtrando registros por:
                                    {this.state.busca && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">Paciente: {this.state.busca}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('busca')} /></span>
                                    )}
                                    {this.state.beneficiario_cpf && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">CPF: {this.state.beneficiario_cpf}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('beneficiario_cpf')} /></span>
                                    )}
                                    {this.state.laboratorio_nome && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">Laboratório: {this.state.laboratorio_nome}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('laboratorio_nome')} /></span>
                                    )}
                                    {this.state.filtro_programa_id && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">Programa: {this.state.filtro_programa_nome}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('programa_id')} /></span>
                                    )}
                                    {this.state.etapa_id && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">Etapa: {this.state.etapa_nome}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('etapa_id')} /></span>
                                    )}
                                    {this.state.status_id && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">Status: {this.state.status_nome}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('status_id')} /></span>
                                    )}
                                    {this.state.cadastro_teste && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">Atendimentos de Teste: {this.state.cadastro_teste === 'True' ? 'Sim' : 'Não'}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('cadastro_teste')} /></span>
                                    )}
                                    {this.state.medico_id && (
                                        <span className="badge text-bg-primary cursor-pointer ms-1 me-1">Médico: {this.state.medico_nome}&nbsp;&nbsp;&nbsp;<FaTimes onClick={() => this.ExcluirFiltro('medico_id')} /></span>
                                    )}
                                    </p>
                                </Col>
                            </Row>
                            );
                        })()}

                    </Card.Body>
                </Card>

                {/* O alternador fica fora do card, colado na listagem/kanban que ele controla.
                    Kanban só faz sentido com um programa definido (as colunas são as etapas
                    dele) e só para quem acompanha a operação. */}
                {usaLayoutNovoListas(this.state.configProgramaAtual)
                    && !!this.getProgramaIdKanban() && this.podeVerKanban() && (
                    <div className="d-flex justify-content-end mb-2">
                        <div className="d-flex align-items-center" style={{ background: '#eaeef4', border: '1px solid #d7dee9', borderRadius: '5px', padding: '2px', gap: '2px' }}>
                            {[
                                { chave: false, rotulo: 'Lista', Icone: FaList },
                                { chave: true, rotulo: 'Kanban', Icone: FaColumns },
                            ].map(({ chave, rotulo, Icone }) => {
                                const ativo = this.state.visao_kanban === chave;
                                return (
                                    <button
                                        key={rotulo}
                                        type="button"
                                        title={`Ver como ${rotulo.toLowerCase()}`}
                                        onClick={() => this.setState({ visao_kanban: chave })}
                                        style={{
                                            border: 0, borderRadius: '3px', padding: '3px 9px', fontSize: '11.5px',
                                            fontWeight: 600, cursor: 'pointer', lineHeight: 1.4, whiteSpace: 'nowrap',
                                            background: ativo ? '#0f2748' : 'transparent',
                                            color: ativo ? '#fff' : '#54627a',
                                        }}
                                    >
                                        <Icone className="me-1" style={{ fontSize: '11px' }} />{rotulo}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* A listagem fica FORA do card branco: ela é uma superfície branca e precisa
                    do cinza da aplicação atrás para se destacar — e assim usa a largura toda,
                    sem espremer as colunas. Mesma decisão da tela de Agendamentos. */}
                {this.state.visao_kanban && this.getProgramaIdKanban() && this.podeVerKanban() ? (
                    <KanbanAtendimentos
                        programaId={this.getProgramaIdKanban()}
                        filtrosBase={this.getFiltrosKanban()}
                    />
                ) : !usaLayoutNovoListas(this.state.configProgramaAtual) ? (
                    <div className="position-relative">
                        {this.renderTabelaAnterior()}
                        {this.state.loading && (
                            <div className="loading-overlay">
                                <div className="loading-spinner">
                                    <Spinner animation="border" />
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="position-relative">
                        <LinhasDensasAtendimentos
                            itens={this.state.listRegistros?.results || []}
                            dadosUsuario={dados_usuario}
                            colunasConfig={this.state.colunas_atendimento_padrao || []}
                            permiteEditar={this.state.permite_editar}
                            liberaColunas={
                                dados_usuario['operador_id'] > 0
                                || dados_usuario['tipo_usuario'] === 'gestor'
                                || dados_usuario['tipo_usuario'] === ''
                                || (dados_usuario['prestador_id'] > 0 && dados_usuario['prestador_categoria'] === 'laboratorio_diagnostico')
                            }
                            ordem={this.state.ordem}
                            ordemDirecao={this.state.ordem_direcao}
                            onOrdenar={this.handleOrderChange}
                            onExcluir={this.excluirAtendimento}
                            onValidar={this.alterarValidacaoAtendimento}
                        />
                        {this.state.loading && (
                            <div className="loading-overlay">
                                <div className="loading-spinner">
                                    <Spinner animation="border" />
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* no kanban cada coluna pagina sozinha, então a paginação geral não se aplica */}
                {!this.state.visao_kanban &&
                    'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 &&
                    <div className="mt-3">
                        <Paginacao dados={this.state.listRegistros} limit={this.state.limite} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(Atendimentos);
